import { Table } from 'antd';
import React, { useEffect } from 'react';
import { useReprice } from './RePriceStore';

function Reprice(props) {
    let {columns, fetchProducts, products} = useReprice()
    useEffect(()=>{
        fetchProducts()
    }, [])
    return (
        <div>
            <h2 style={{marginBottom: '20px'}}>Maxsulotlar sotuv narxini o'zgartirish</h2>
            <Table bordered rowKey={'id'} columns={columns} dataSource={products} />
        </div>
    );
}

export default Reprice;